import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function BlackList({ nonPaidCustomers = [] }) {
  return (
    <MDBox>
      <MDTypography variant="h6" color="dark" mb={2}>
        Kara Liste
      </MDTypography>
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          height: "400px",
          overflow: "auto",
          border: "1px solid #e9ecef",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f8f9fa" }}>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "left",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Müşteri Adı
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "right",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Borç Tutarı
              </th>
              <th
                style={{
                  padding: "12px 16px",
                  textAlign: "right",
                  borderBottom: "1px solid #e9ecef",
                  color: "#344767",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                Gecikme Süresi
              </th>
            </tr>
          </thead>
          <tbody>
            {nonPaidCustomers.length > 0 ? (
              nonPaidCustomers.slice(0, 10).map((customer, index) => (
                <tr
                  key={index}
                  style={{
                    borderBottom: "1px solid #e9ecef",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.target.parentElement.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.target.parentElement.style.backgroundColor = "transparent";
                  }}
                >
                  <td
                    style={{
                      padding: "12px 16px",
                      color: "#344767",
                      fontSize: "14px",
                    }}
                  >
                    {customer.customerName || "Bilinmeyen Müşteri"}
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "right",
                      color: "#e53e3e",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    {customer.pendingAmount ? customer.pendingAmount.toLocaleString("tr-TR") : 0} ₺
                  </td>
                  <td
                    style={{
                      padding: "12px 16px",
                      textAlign: "right",
                      color: "#e53e3e",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    {customer.delayDay ? customer.delayDay.toLocaleString("tr-TR") : 0} gün
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={2}
                  style={{
                    padding: "24px 16px",
                    textAlign: "center",
                    color: "#344767",
                    fontSize: "14px",
                  }}
                >
                  Kara listede müşteri bulunmuyor
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </MDBox>
  );
}

BlackList.propTypes = {
  nonPaidCustomers: PropTypes.arrayOf(
    PropTypes.shape({
      customerName: PropTypes.string,
      pendingAmount: PropTypes.number,
    })
  ),
};

export default BlackList;
